import React from "react";
import "./PriceTable.css";
import logo from "../assets/logo.png";
import PriceTableHeader from "./PriceTableHeader";

function PriceTable({ data }) {
    const isString = (value) => {
        return typeof value === "string" || value instanceof String;
    };

    const renderNumber = (number) => {
        try {
            if (!number) return "-";
            if (isString(number)) {
                return number;
            } else {
                return number.toLocaleString("en-US");
            }
        } catch (e) {
            return "-";
        }
    };

    return (
        <div className="price-table-container mt-10">
            <PriceTableHeader title="BẢNG GIÁ VÀNG TRỰC TUYẾN" />

            <div className="location-bar">
                <span className="unit-text">ĐVT: 1=1.000 VNĐ/ Chỉ</span>
            </div>

            <div className="price-grid">
                <div className="grid-header">THƯƠNG PHẨM</div>
                <div className="grid-header">LOẠI VÀNG</div>
                <div className="grid-header">HÀM LƯỢNG</div>
                <div className="grid-header">MUA VÀO</div>
                <div className="grid-header">BÁN RA</div>

                {data && data.length > 0 ? (
                    data.map((item, idx) => {
                        const rowClass = idx % 2 === 0 ? "row-even" : "row-odd";
                        return (
                            <React.Fragment key={idx}>
                                <div className={`grid-item side-banner ${rowClass}`}>
                                    <img src={logo} alt="product" className="banner-img" />
                                </div>
                                <div className={`grid-item type-info ${rowClass}`}>
                                    <b className="gold-type">{item.Type}</b>
                                    <span className="gold-desc">CHẤT LƯỢNG QUỐC TẾ</span>
                                </div>
                                <div className={`grid-item purity ${rowClass}`}>
                                    {item.Purity}
                                </div>
                                <div className={`grid-item price buy ${rowClass}`}>
                                    {renderNumber(item.Buy)}
                                </div>
                                <div className={`grid-item price sell ${rowClass}`}>
                                    {renderNumber(item.Sell)}
                                </div>
                            </React.Fragment>
                        );
                    })
                ) : (
                    <div className="loading-state">
                        Đang tải dữ liệu giá vàng...
                    </div>
                )}
            </div>
        </div>
    );
}

export default PriceTable;
